export default __webpack_public_path__ + "static/media/polygon.78d7108c.svg";